import React from 'react';

import { HowToPlay } from '../PopUps/HowToPlay/HowToPlay';
import { Credits } from '../PopUps/Credits/Credits';

interface DropDownMenuProps {
  openModalCallback?: (modalName: string) => void;
}

interface DropDownMenuState {
  open: boolean;
  settingsOpen: boolean;
  howToPlayOpen: boolean;
  creditsOpen: boolean;
}

export class DropDownMenu extends React.Component<DropDownMenuProps, DropDownMenuState> {
  constructor(props: DropDownMenuProps){
    super(props);
    this.state = {open: false, settingsOpen: false, howToPlayOpen: false, creditsOpen: false};
  }

  componentDidMount(): void {
    document.addEventListener('click', (e) => this.handleClick(e));
  }

  componentWillUnmount(): void {
    document.removeEventListener('click', (e) => this.handleClick(e))
  }

  handleClick(e: MouseEvent){
    if(!this.state.open) return;
    if((e.target as HTMLElement).id === 'DropDownOpener') return;
    this.close();
    e.stopPropagation();
  }

  open(){
    this.setState( (prevState) => {
      return {
        ...prevState,
        open: true,
      }
    })
  }

  close(){
    this.setState( (prevState) => {
      return {
        ...prevState,
        open: false,
      }
    })

  }

  toggleSettings(on: boolean){
    this.setState({
        open: false,
        settingsOpen: on,
        howToPlayOpen: false,
        creditsOpen: false,
    });
  }

  toggleTutorial(on: boolean){
    this.setState({
        open: false,
        settingsOpen: false,
        howToPlayOpen: on,
        creditsOpen: false,
    });
  }

  toggleCredits(on: boolean){
    this.setState({
        open: false,
        settingsOpen: false,
        howToPlayOpen: false,
        creditsOpen: on,
    });
  }



  render(): React.ReactNode {
    return (
      <div className='absolute text-xl text-center cursor-pointer right-4 md:text-3xl text-onBackgroundTextColor'>
        <div 
          id='DropDownOpener'
          className='flex flex-col items-center justify-center w-8 h-8 gap-1 md:gap-2'
          onClick={(e) => {
            if((e.target as HTMLElement).id !== 'DropDownOpener') return;
            this.state.open ? this.close() : this.open();
            }}>
          <div className='w-2/3 md:w-full h-0.5 pointer-events-none rounded-l-md rounded-r-md bg-onBackgroundTextColor'/>
          <div className='w-2/3 md:w-full h-0.5 pointer-events-none rounded-l-md rounded-r-md bg-onBackgroundTextColor'/>
          <div className='w-2/3 md:w-full h-0.5 pointer-events-none rounded-l-md rounded-r-md bg-onBackgroundTextColor'/>
        </div>
        {/* DropDownMenu */}

        {this.state.open &&
        <div className='absolute right-0 z-50 flex flex-col w-[40dvw] md:w-[30dvw] lg:w-[20dvw] overflow-hidden text-xl rounded shadow-lg bg-modalBackground text-white'>
        <button className = 'border-b-2 border-white' onClick={() => {this.close(); this.toggleTutorial(true);}}> How to Play </button>
        <button onClick={() => {this.close(); this.toggleCredits(true);}}> Credits </button>
        </div> 
        }

        {this.state.howToPlayOpen && <HowToPlay closeCallback={() => this.toggleTutorial(false)}></HowToPlay>}
        {this.state.creditsOpen && <Credits closeCallback={() => this.toggleCredits(false)}></Credits>}
        
      </div>
    );
  }
}
